<template>
  <div class="glass-theme fade-in-page">
    <div style="width: 100%; padding: 10px;">
      <h5>SALES DELIVERY LIST</h5>

      <b-modal id="modal-ds-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
        <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
      </b-modal>

      <!-- Mobile filter toggle -->
      <div
        v-if="isMobile"
        class="d-flex justify-content-between align-items-center mb-2 py-2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          @click="filtersVisible = !filtersVisible"
          class="glass-btn-outline"
        >
          <b-icon-funnel-fill class="mr-1" />
          {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
        </b-button>
      </div>

      <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
        <b-alert variant="secondary" show style="width: 100%;" class="glass-filters">
          <div style="display: block;">
            <!-- DATE RANGE PICKER -->
            <div style="display: inline-block; vertical-align: top; margin-right: 10px;">
              <div>DATE RANGE</div>
              <b-input
                id="delivery-dates"
                size="lg"
                :placeholder="[query.startDate, query.endDate].join(' - ')"
                style="width: 220px; font-size: 14px; font-weight: bold;"
                autocomplete="off"
                class="glass-input"
              ></b-input>
              <b-button
                size="sm"
                variant="dark"
                @click="search_dates"
                style="margin-top: 5px;"
                class="glass-btn-small"
              >SEARCH</b-button>
            </div>

            <!-- INVOICE SEARCH -->
            <div style="display: inline-block; vertical-align: top; margin-right: 10px;">
              <div>INVOICE # / NAME / PHONE</div>
              <b-form @submit="search_invoice" style="display: inline-block;">
                <b-form-input
                  v-model="query.invoice_id"
                  size="lg"
                  style="width: 220px; font-size: 14px; font-weight: bold; display: inline-block;"
                  autocomplete="off"
                  class="glass-input"
                ></b-form-input>
                <b-button type="submit" size="sm" variant="dark" style="margin-top: 5px;" class="glass-btn-small">SEARCH</b-button>
              </b-form>
            </div>

            <!-- DELIVERY TYPE FILTER -->
            <div style="display: inline-block; vertical-align: top; margin-right: 10px;" v-if="items.length > 0">
              <div>FILTER ORDER TYPE</div>
              <b-form-select size="lg" :options="delivery_type_options" v-model="selected_delivery_type" style="width: 180px; font-size: 17px; font-weight: bold;" class="glass-select">
                <template #first>
                  <b-form-select-option :value="null">ALL</b-form-select-option>
                </template>
              </b-form-select>
            </div>

            <!-- TRUCK FILTER -->
            <div style="display: inline-block; vertical-align: top; margin-right: 10px;" v-if="items.length > 0 && ['admin', 'locationadmin', 'locationmanager', 'warehousemanager'].includes(packet.userDetails.userrole)">
              <div>FILTER DLVRY TRUCK</div>
              <b-form-select size="lg" :options="packet.trucks" v-model="picked_truck" style="width: 180px; font-size: 17px; font-weight: bold;" class="glass-select">
                <template #first>
                  <b-form-select-option :value="null">ALL</b-form-select-option>
                </template>
              </b-form-select>
            </div>

            <!-- LOCATION FILTER -->
            <div style="display: inline-block; vertical-align: top; margin-right: 10px;" v-if="items.length > 0 && ['admin', 'officeuser', 'officemanager', 'warehousemanager'].includes(packet.userDetails.userrole)">
              <div>FILTER SOLD LOC</div>
              <b-form-select size="lg" :options="filter_locations(packet.locations)" v-model="picked_location_id" style="width: 180px; font-size: 17px; font-weight: bold;" class="glass-select">
              </b-form-select>
            </div>

            <!-- DOWNLOAD EXCEL -->
            <div style="display: inline-block; vertical-align: top;" v-if="items.length > 0 && ['admin', 'locationadmin', 'locationmanager', 'warehousemanager'].includes(packet.userDetails.userrole) && picked_truck != null">
              <div>&nbsp;</div>
              <download-csv
                class="btn glass-btn"
                :data="get_csv_data()"
                style="border: 1px solid black; width: 180px; background: black; color: white; padding: 8px;"
                :name="get_csv_filename()">
                DOWNLOAD EXCEL
              </download-csv>
            </div>
          </div>
        </b-alert>
      </b-collapse>

      <div style="width: 100%;">
        <div v-if="items_being_loaded == true">
          <loading :active="true" :can-cancel="false" :is-full-page="true"></loading>
        </div>

        <div v-else-if="items_being_loaded == false">
          <div v-if="items.length > 0" class="diver">
            <b-alert show variant="secondary" v-for="item, idx in items" v-bind:key="idx" v-if="allowed_invoice_truck(item) && allowed_invoice_location(item) && filter_delivery_type(item)" class="glass-card-inner fade-in-row" :style="{ animationDelay: `${idx * 0.02}s` }">
              <table style="width: 100%">
                <thead>
                  <tr>
                    <th class="srr" style="min-width: 100px;" @click="sortby('invoice_id')">INVOICE #</th>
                    <th class="srr" style="min-width: 100px;" @click="sortby('order_type')">ORDER TYPE</th>
                    <th class="srr" style="min-width: 200px;" @click="sortby('location_id')">SOLD FROM</th>
                    <th class="srr" style="min-width: 50px;" @click="sortby('cubes')">CUBES</th>
                    <th class="srr" style="min-width: 100px;" @click="sortby('fullname')">CUSTOMER</th>
                    <th class="srr" style="min-width: 200px;" @click="sortby('address')">ADDRESS</th>
                    <th class="srr" style="min-width: 50px;" @click="sortby('zipcode')">ZIPCODE</th>
                    <th class="srr" style="min-width: 100px;" @click="sortby('city')">CITY</th>
                    <th class="srr" style="min-width: 100px;" @click="sortby('state')">STATE</th>
                    <th class="srr" style="min-width: 100px;" @click="sortby('phone')">PHONE</th>
                    <th class="srr" style="min-width: 100px;" @click="sortby('truck')">TRUCK</th>
                    <th class="srr" style="min-width: 50px;">DELIVERED</th>
                    <th class="srr" style="min-width: 80px;">ACTION</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td class="srrv" :style="{'background': get_bg(item)}">
                      {{ item.invoice_id }}
                    </td>
                    <td class="srrv">
                      {{ item.order_type.toUpperCase().replace('_', ' ') }}
                    </td>
                    <td class="srrv">
                      {{ packet.locsubsdict[item.location_id+'|'+item.sublocation_id] }}
                    </td>
                    <td class="srrv">{{ item.cubes }}</td>
                    <td class="srrv">{{ (item.fullname || '').toUpperCase() }}</td>
                    <td class="srrv">{{ (item.address || '').toUpperCase() }}</td>
                    <td class="srrv">{{ (item.zipcode || '').toUpperCase() }}</td>
                    <td class="srrv">{{ (item.city || '').toUpperCase() }}</td>
                    <td class="srrv">{{ (item.state || '').toUpperCase() }}</td>
                    <td class="srrv">{{ (item.phone || '').toUpperCase() }}</td>
                    <td class="srrv">{{ (packet.trucksdict[item.truck] || '').toUpperCase() }}</td>
                    <td class="srrv">{{ find_ndelivered(item.items) }} / {{ item.items.length }}</td>
                    <td class="srrv">
                      <b-button show class="glass-btn-small" style="display: inline-block; vertical-align: top; font-size: 14px; padding: 3px;" @click="item.show_detail = !item.show_detail;">
                        ITEMS
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div style="display: block; margin-top: 5px;" v-if="item.show_detail">
                <table style="width: 100%; background: #fffce7; font-size: 13px;">
                  <thead>
                    <tr>
                      <th class="srr" style="min-width: 50px;">GROUP</th>
                      <th class="srr" style="min-width: 80px;">PRODUCT SKU</th>
                      <th class="srr" style="min-width: 100px;">PRODUCT NAME</th>
                      <th class="srr" style="min-width: 30px;">QTY</th>
                      <th class="srr" style="min-width: 100px;">DEL QTY</th>
                      <th class="srr" style="min-width: 130px;">ORIGINAL LOCATION</th>
                      <th class="srr" style="min-width: 150px;">CURRENT LOCATION</th>
                      <th class="srr" style="min-width: 150px;">STAGING LOCATION</th>
                      <th class="srr" style="min-width: 160px;">LOAD FROM</th>
                      <th class="srr" style="min-width: 80px;">TRUCK</th>
                      <th class="srr" style="min-width: 100px;">SPECIAL/REGULAR</th>
                      <th class="srr" style="min-width: 100px;">DELIVERY DATE</th>
                      <th class="srr" style="min-width: 100px;">STATUS</th>
                      <th class="srr" style="min-width: 100px;">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="element, eidx in item.items" v-bind:key="eidx" v-if="allowed_element(element)">
                      <td class="srrv2">{{ (element.parent_product_sku || 'N/A').toUpperCase() }}</td>
                      <td class="srrv2">{{ (element.product_sku || '').toUpperCase() }}</td>
                      <td class="srrv2">{{ (element.product_name || '').toUpperCase() }}</td>
                      <td class="srrv2">{{ element.quantity }}</td>
                      <td class="srrv2">
                        <span>{{ element.quantity }} / </span>
                        <b-form-input
                          type="number"
                          min="0"
                          :max="element.quantity"
                          v-model.number="element.quantity_delivered"
                          style="width: 50px; height: 27px; display: inline-block; font-size: 13px;"
                          @input="handlePartialState(element)"
                          :disabled="is_action_disabled(element)"
                        ></b-form-input>
                      </td>
                      <td class="srrv2">{{ packet.locsubsdict[element.original_locsub] }}</td>
                      <td class="srrv2">{{ packet.locsubsdict[element.locsub] }}</td>
                      <td class="srrv2">{{ packet.locsubsdict[element.ship_locsub] }}</td>
                      <td class="srrv2">{{ packet.locsubsdict[element.drop_locsub] }}</td>
                      <td class="srrv2">{{ (packet.trucksdict[element.truck] || 'NO TRUCK').toUpperCase() }}</td>
                      <td class="srrv2">
                        <span v-if="element.is_special" style="background: pink;"><b>SPECIAL</b></span>
                        <span v-else><b>REGULAR</b></span>
                      </td>
                      <td class="srrv2">
                        {{ formatDeliveryDate(element.delivery_date) }}
                      </td>
                      <td class="srrv2">
                        <b-form-select
                          :options="getStatesWithPartial()"
                          v-model="element.state"
                          @change="onStateChange(element)"
                          size="sm"
                          style="font-size: 13px;"
                          :disabled="element.quantity == 0 || is_action_disabled(element)">
                        </b-form-select>
                      </td>
                      <td class="srrv2">
                        <div style="display: flex; align-items: center; justify-content: center; gap: 2px;">
                          <b-button
                            size="sm"
                            variant="outline-success"
                            @click="update_n_delivered(item, element)"
                            v-b-tooltip.hover
                            title="SAVE"
                            :disabled="item_update_loader || is_action_disabled(element)"
                          >
                            <span v-if="!item_update_loader">
                              <b-icon icon="check-square" aria-hidden="true"></b-icon>
                            </span>
                            <span v-else>
                              <loading :active="true" :can-cancel="false" :is-full-page="false"></loading>
                            </span>
                          </b-button>
                          <b-button size="sm" @click="show_comments(element)">CMNT</b-button>
                          <b-button size="sm" v-if="element.state == 1 || element.state == -8">RMT</b-button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-alert>
          </div>

          <!-- No results message -->
          <div v-else style="text-align: center; padding: 40px; color: #666;" class="glass-card-inner">
            <p>No delivery items found for the selected criteria.</p>
          </div>
        </div>

        <div v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import mappings from '@/utilities/mappings';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import draggable from 'vuedraggable';
import { BIconFunnelFill } from "bootstrap-vue";
import ItemComments from '@/components/importables/ItemComments';

export default {
  name: "DeliveriesLoading2",
  components: { flatPickr, Loading, ItemComments, draggable },
  data: function() {
    return {
      dates: [],
      items: [],
      packet: {},
      truck_dates_being_loaded: false,
      items_being_loaded: false,
      date: null,
      truck: null,
      trucks: [],
      locations: [],
      item_comments_invoice_id: null,
      item_comments_itemid: null,
      location_id: null,
      delivery_ranks: [],
      delivery_rank_map: {},
      colors_dict: {},
      states: mappings.states.map(function(d) { 
        if ([32, 12, -12, 1, -7, -8].includes(d.value)) { d.disabled = false } else { d.disabled = true }; 
        return d 
      }),
      states_dict: mappings.states_dict,
      merchandise_statuses_dict: mappings.merchandise_statuses_dict,
      ranks: [],
      sort_asc: false,

      query: {
        startDate: null,
        endDate: null,
        invoice_id: null,
      },

      picked_location_id: null,
      picked_truck: null,
      delivery_type_options: [
        { value: "home_delivery", text: 'HOME DELIVERY' },
        { value: "store_pickup", text: 'STORE PICKUP' },
      ],
      selected_delivery_type: null,
      item_update_loader: false,
      filtersVisible: true,
      isMobile: false,
      datePicker: null,
    }
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },

    formatDeliveryDate: function(dateString) {
      if (!dateString) return 'N/A';
      try {
        return moment(dateString).format('MM-DD-YYYY');
      } catch (e) {
        return dateString;
      }
    },

    search_dates: function() {
      this.query.invoice_id = null;
      this.fetch_delivery_items();
    },

    search_invoice: function(e) {
      if (e) e.preventDefault();
      if (!this.query.invoice_id) {
        this.$bvToast.toast("Please specify a valid invoice id", { title: "Error", autoHideDelay: 1500, variant: "warning" });
        return;
      }
      this.query.startDate = null;
      this.query.endDate = null;
      this.fetch_delivery_items();
    },

    fetch_delivery_items: function() {
      let path = "/api/sales/get_delivery_items_for_date/";
      let that = this;
      
      let data = {
        date: null,
        start_date: this.query.invoice_id ? null : this.query.startDate,
        end_date: this.query.invoice_id ? null : this.query.endDate,
        invoice_id: this.query.invoice_id,
        merchandise_status: [1]
      };

      if (this.packet.userDetails.userrole == 'deliverytruck') {
        data.truck = this.packet.userDetails.id;
      }

      if (['locationadmin', 'salesperson', 'locationuser'].includes(this.packet.userDetails.userrole)) {
        let location_id = parseInt(this.packet.userDetails.properties.location_id);
        if (location_id) {
          data.sold_location_id = location_id;
        }
      }

      let s = function(response) {
        if (response.data.result) {
          that.items = response.data.result;
          that.delivery_ranks = that.items.map(function(d, i) { return { text: i + 1, value: i + 1 } });
          that.items.forEach(item => {
            item.items.forEach(element => {
              element.original_state = element.state;
              element.original_quantity_delivered = element.quantity_delivered;
            });
          });
        } else {
          that.$bvToast.toast(
            response.data.error,
            { title: "Error", autoHideDelay: 1500, variant: "warning" }
          );
        }
        that.items_being_loaded = false;
      }

      let f = function(error) {
        console.log(error);
        that.$bvToast.toast(
          "Error loading items to be delivered.",
          { title: "Error", autoHideDelay: 1500, variant: "danger" }
        );
        that.items_being_loaded = false;
      }

      this.items = [];
      this.picked_truck = null;
      this.delivery_ranks = [];
      this.picked_location_id = null;
      this.items_being_loaded = true;
      this.selected_delivery_type = null;
      
      Requestor.postSyncP(path, data, this, s, f);
    },

    find_ndelivered: function(items) {
      return items.filter(function(d) { return d.state == 1 || d.state == -8 }).length
    },

    allowed_element: function(element) {
      let status = true;
      if (element.locsub) {
        const [locationId] = element.locsub.toString().split('|');
        if (parseInt(locationId) === 46) {
          return false;
        }
      }

      if (this.picked_truck) {
        if (element.truck != this.picked_truck) {
          status = false
        } else {
          status = true
        }
      } else {
        status = true
      }
      return status
    },

    allowed_invoice_truck: function(item) {
      let status = true;
      let that = this;
      if (this.picked_truck) {
        let n = item.items.filter(function(d) { return d.truck == that.picked_truck }).length;
        if (n == 0) {
          status = false
        } else {
          status = true
        }
      } else {
        status = true;
      }
      return status
    },

    allowed_invoice_location: function(item) {
      let status = true;
      if (this.picked_location_id) {
        if (item.location_id != this.picked_location_id) {
          status = false
        } else {
          status = true
        }
      }
      return status
    },

    filter_delivery_type: function(item) {
      let status = true;
      if (this.selected_delivery_type) {
        if (item.order_type != this.selected_delivery_type) {
          status = false
        } else {
          status = true
        }
      }
      return status
    },

    update_n_delivered: function(item, ditem) {
      item.n_delivered = item.items.filter(function(d) { return d.state == 1 }).length;
      this.update_invoice_item_state(item, ditem);
    },

    get_bg: function(item) {
      let contains_discrepant = item.items.filter(function(d) { return d.state < 0 }).length;
      if (contains_discrepant) {
        return '#ff8a65'
      } else {
        let n_delivered = this.find_ndelivered(item.items);
        if (n_delivered != item.items.length) {
          if (n_delivered == 0) {
            return 'white'
          } else {
            return 'lightyellow'
          }
        } else {
          return 'lightgreen'
        }
      }
    },

    show_comments: function(item) {
      this.item_comments_invoice_id = item.invoice_id;
      this.item_comments_itemid = item.itemid;
      this.$bvModal.show("modal-ds-comments");
    },

    fetch_invoice_data: function(invoice_id) {
      let path = "/api/sales/get_invoice/";
      let that = this;
      let data = { invoice_id: invoice_id };
      return new Promise((resolve, reject) => {
        let s = function(response) {
          if (response.data.result) {
            resolve(response.data.result);
          } else {
            reject(response.data.error);
          }
        }
        let f = function(error) {
          reject(error);
        }
        Requestor.postAsyncP(path, data, this, s, f);
      });
    },

    update_invoice_item_state: async function(item, element) {
      let path = "/api/sales/update_invoice_item_state/";
      let that = this;
      that.item_update_loader = true;

      try {
        let data = {
          invoice_id: element.invoice_id,
          itemid: element.itemid,
          state: element.state,
          changed_by: this.packet.userDetails.username,
          product_sku: element.product_sku,
          quantity: element.quantity
        }

        await new Promise((resolve, reject) => {
          let s = function(response) {
            if (response.data.error) {
              reject(response.data.error);
            } else {
              resolve(response.data);
            }
          }
          let f = function(error) {
            reject(error);
          }
          Requestor.postAsyncP(path, data, that, s, f);
        });

        that.$bvToast.toast("Success updating item state.", { title: "Success", autoHideDelay: 1500, variant: "success" });
        that.item_update_loader = false;
      } catch (error) {
        console.error("Error in state update:", error);
        that.$bvToast.toast("Error updating item state: " + error.message, { title: "Error", autoHideDelay: 1500, variant: "warning" });
        that.item_update_loader = false;
      }
    },

    is_action_disabled: function(element) {
      const userrole = this.packet.userDetails.userrole;
      const userLocationId = parseInt(this.packet.userDetails.properties.location_id);
      if (['accountmanager', 'salesperson', 'housetruck'].includes(userrole)) {
        return true;
      }
      if (userrole === 'locationadmin') {
        if (!element || !element.locsub) return true;
        const [locId] = element.locsub.toString().split('|');
        return parseInt(locId) !== userLocationId;
      }
      return false;
    },

    handlePartialState(element) {
      this.$nextTick(() => {
        if (element.quantity_delivered < 0) {
          element.quantity_delivered = 0;
        }
        if (element.quantity_delivered > element.quantity) {
          element.quantity_delivered = element.quantity;
        }
        if (element.quantity_delivered > 0 && element.quantity_delivered < element.quantity) {
          element.state = 31;
        } else if (element.quantity_delivered > 0 && element.quantity_delivered == element.quantity) {
          element.state = 1;
        } else {
          element.state = element.original_state;
        }
      })
    },

    getStatesWithPartial() {
      return [...this.states, { "value": 31, "text": "PARTIAL" }];
    },

    onStateChange: function(element) {
      if (element.state == 1) {
        element.quantity_delivered = element.quantity
      }
    },

    filter_locations: function(locations) {
      let userrole = this.packet.userDetails.userrole;
      let userLocationId = this.packet.userDetails.properties.location_id;
      if (userrole == 'admin' || userrole == 'officeuser') {
        return locations.filter(d => ![44, 46].includes(d.value));
      } else {
        if (userLocationId) {
          return locations.filter(function(d) { return d.value == userLocationId; });
        } else {
          return locations.filter(function(d) { return d.is_main_warehouse == true; });
        }
      }
    },

    sortby: function(key, mapper) {
      if (this.sort_asc) {
        this.items = Requestor.sort(this.items, key, mapper)
      } else {
        this.items = Requestor.sort_reverse(this.items, key, mapper)
      }
      this.sort_asc = !this.sort_asc;
    },

    get_csv_filename: function() {
      let startDate = this.query.startDate || '';
      let endDate = this.query.endDate || '';
      let picked_truck = (this.packet.trucksdict[this.picked_truck] || '').toUpperCase();
      return "DELIVERY_LIST_" + startDate + "_" + endDate + "_" + picked_truck + ".csv"
    },

    get_csv_data: function() {
      let data = []
      let items = this.items;
      let that = this;
      items = items.filter(function(item) { return that.allowed_invoice_truck(item) && that.allowed_invoice_location(item) });
      if (items.length > 0) {
        for (var i = 0; i < items.length; i++) {
          let row = items[i];
          for (var j = 0; j < items[i].items.length; j++) {
            let element = items[i].items[j];
            if (this.allowed_element(element)) {
              let k = {};
              k["Bill To Name"] = row.fullname;
              k["Email Address"] = row.email;
              k["Ship-to Name"] = row.fullname;
              k["Ship-to Phone"] = row.phone.replace(/\(/g, "").replace(/\)/g, "");
              k["Ship-to Address Line 1"] = row.address
              k["Ship-to Address Line 2"] = ""
              k["Ship-to City"] = row.city;
              k["Stst"] = row.state;
              k["St Postal"] = row.zipcode;
              k["Order No"] = row.invoice_id;
              k["Store"] = this.packet.locsubsdict[row.location_id + "|" + row.sublocation_id];
              k["Tr Cd"] = 0;
              k["Order Total"] = 0.0;
              k["Product Description"] = element.product_name;
              k["Stk Lc"] = this.packet.locsubsdict[element.locsub];
              k["Product Number"] = element.product_sku;
              k["Qty Ord"] = element.quantity;
              k["Qty Rsvd"] = element.quantity;
              k["Case Price"] = 0.0;
              k["Volume"] = element.cubes;
              k["Del Dates"] = new moment(element.delivery_date).format("MM/DD/YYYY");
              data.push(k)
            }
          }
        }
      }
      return data
    },
  },

  mounted: function() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    const Lightpick = require("lightpick");
    let that = this;
    
    const today = moment();
    const twoDaysAgo = moment().subtract(1, 'days');
    this.query.startDate = twoDaysAgo.format('YYYY-MM-DD');
    this.query.endDate = today.format('YYYY-MM-DD');

    this.datePicker = new Lightpick({
      field: document.getElementById("delivery-dates"),
      singleDate: false,
      repick: true,
      onSelect: function(start, end) {
        that.query.startDate = start ? start.startOf("day").format("YYYY-MM-DD") : "";
        that.query.endDate = end ? end.endOf("day").format("YYYY-MM-DD") : "";
      },
    });

    this.fetch_delivery_items();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  created: function() {
    this.packet = JSON.parse(localStorage.packet);
    this.packet.userDetails = JSON.parse(localStorage.userDetails);
  }
}
</script>

<style scoped>
/* Glass Theme Background */
.glass-theme {
  position: relative;
  background: transparent !important;
  min-height: 100vh;
}

.glass-theme::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(10px);
  opacity: 0.5;
  z-index: -2;
  transform: scale(1.1);
}

/* Page Entrance Animation */
@keyframes fadeInPage {
  from {
    opacity: 0;
    transform: translateY(24px);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

.fade-in-page {
  animation: fadeInPage 0.7s cubic-bezier(0.2, 0.9, 0.4, 1.1);
}

/* Row Fade Animation */
@keyframes fadeInRow {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.fade-in-row {
  opacity: 0;
  animation: fadeInRow 0.28s cubic-bezier(0.2, 0.9, 0.4, 1) forwards;
}

/* Glass Filters */
.glass-filters {
  background: rgba(255, 255, 255, 0.55) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 20px !important;
}

/* Glass Card Inner */
.glass-card-inner {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 12px !important;
  margin-bottom: 8px;
}

/* Glass Input */
.glass-input {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(128, 128, 128, 0.3) !important;
  border-radius: 10px !important;
}

.glass-input:focus {
  border-color: rgba(54, 64, 80, 0.5) !important;
  box-shadow: 0 0 0 2px rgba(54, 64, 80, 0.1) !important;
}

/* Glass Select */
.glass-select {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(128, 128, 128, 0.3) !important;
  border-radius: 10px !important;
}

/* Glass Button Small */
.glass-btn-small {
  background: rgba(54, 64, 80, 0.85) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 4px 12px !important;
  transition: all 0.2s ease !important;
}

.glass-btn-small:hover {
  background: rgba(54, 64, 80, 1) !important;
  transform: translateY(-1px) !important;
}

.glass-btn {
  background: linear-gradient(135deg, rgba(54, 64, 80, 0.9), rgba(54, 64, 80, 0.95)) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  transition: all 0.2s ease !important;
  border-radius: 10px !important;
}

.glass-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(54, 64, 80, 1), rgba(54, 64, 80, 1)) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.glass-btn-outline {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(54, 64, 80, 0.3) !important;
  transition: all 0.2s ease !important;
  border-radius: 10px !important;
}

.glass-btn-outline:hover {
  background: rgba(54, 64, 80, 0.1) !important;
  transform: translateY(-1px) !important;
}

/* Table Styles */
.diver {
  overflow: auto;
  width: 100%;
  height: 800px;
}

.srr {
  font-size: 11px;
  text-align: center;
  background: #efefef;
  border: 1px solid #010101;
}

.srrv {
  font-size: 13px;
  text-align: center;
  background: white;
  border: 1px solid #010101;
  padding: 5px;
  background-color: #e1f5fe;
}

.srrv2 {
  font-size: 13px;
  text-align: center;
  background: white;
  border: 1px solid #010101;
  padding: 5px;
  background-color: #fffce7;
}

@media (max-width: 768px) {
  .diver {
    height: auto;
    overflow-x: auto;
    overflow-y: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/DeliveriesShipping.vue